import { render, staticRenderFns } from "./ShowAllNotifications.vue?vue&type=template&id=7e46c730&scoped=true"
import script from "./ShowAllNotifications.vue?vue&type=script&lang=js"
export * from "./ShowAllNotifications.vue?vue&type=script&lang=js"
import style0 from "./ShowAllNotifications.vue?vue&type=style&index=0&id=7e46c730&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e46c730",
  null
  
)

export default component.exports